import React, { useState } from "react";
import Webcam from "react-webcam";
import "./WebCapture.css";
import { getPresignedUrl } from "../../common/constants/api";
import { getUserId } from "../../common/utils/cookie-utils";
import axios from "axios";
import { UpdateKYCstepAPI } from "../../common/constants/api";

const videoConstraints = {
	width: 200,
	height: 200,
	facingMode: "user",
};

const WebcamCapture = (props) => {
	const webcamRef = React.useRef(null);
	const mobile_ref = React.useRef(null);

	const [selfie_url = null, setSelfieUrl] = useState(null);
	const [capturePic = null, captureEvent] = useState(0);
	const [SelfiePhoto = null, SlefiePhotoHandler] = useState(0);
	const [has_permission, setPermission] = useState(true);
	const [loading, setLoading] = useState(true);

	const capture1 = React.useCallback(() => {
		const imageSrc = webcamRef.current.getScreenshot();
		setSelfieUrl(imageSrc);
		captureEvent(true);
		// let image_data = imageSrc.replace('data:image/jpeg;base64,', '')

		function urltoFile(url, filename, mimeType) {
			return fetch(url)
				.then(function(res) {
					return res.arrayBuffer();
				})
				.then(function(buf) {
					return new File([buf], filename, { type: mimeType });
				});
		}

		urltoFile(imageSrc, "selfie.jpeg", "image/jpeg").then(function(file) {
			SlefiePhotoHandler(file);
		});
	}, [webcamRef]);
	const CaptureEventHandlerOK = () => {
		let body = {
			partnerId: parseInt(getUserId()),
			kycStepId: 4,
			docTypeId: 6,
			fileType: "jpeg",
		};

		getPresignedUrl(body)
			.catch((error) => {
				console.log({ error: error });
			})
			.then((data) => {
				axios
					.put(data.url, SelfiePhoto, {
						headers: {
							"Content-Type": "application/octet-stream",
						},
					})
					.then((res) => {
						if (window.innerWidth > 768) {
							// props.componentHandler(7)
						}
					});
				UpdateKYCstepAPI({
					url: data.url,
					requestId: data.requestId,
				}).catch((err) => console.log(err));
			})
			.catch((e) => {
				console.log({ error: e });
			});
	};

	const mobile_capture = React.useCallback(() => {
		SlefiePhotoHandler(mobile_ref.current.files[0]);

		let file_reader = new FileReader();
		file_reader.onloadend = function() {
			let a = file_reader.result;
			setSelfieUrl(a);
			captureEvent(true);
			CaptureEventHandlerOK();
		};

		file_reader.readAsDataURL(mobile_ref.current.files[0]);
	});
	const CaptureEventHandlerReTake = () => {
		captureEvent(false);
		setSelfieUrl(null);
	};

	{
		loading
			? (setLoading(false),
			  navigator.permissions
					.query({ name: "camera" })
					.then(function(permissionStatus) {
						permissionStatus.onchange = function() {
							if (this.state == "granted" || this.state == "prompt") {
								setPermission(true);
							} else if (this.state == "denied") {
								setPermission(false);
							}
						};
					})
					.catch((error) => console.log(error)))
			: null;
	}

	return (
		<>
			<div className="w-full">
				<div className="mx-auto container_23">
					{!selfie_url ? (
						<div className="block w-full mx-auto">
							{has_permission ? (
								<div className="hidden md:block">
									<Webcam
										audio={false}
										height={200}
										ref={webcamRef}
										screenshotFormat="image/jpeg"
										width={200}
										videoConstraints={videoConstraints}
									/>
								</div>
							) : null}
							<div className="hidden">
								<input
									type="file"
									accept="image/*"
									capture="user"
									ref={mobile_ref}
									id="selfie_mobile_01234"
									onChange={mobile_capture}
								/>
							</div>
						</div>
					) : (
						<div className="">
							<img
								className="mr-auto web_photo_123"
								src={selfie_url}
								alt="selfie"
							/>
						</div>
					)}
				</div>
				{capturePic ? (
					<div
						className="hidden md:block mx-auto flex mt-6"
						style={{ width: "400px" }}
					>
						<button
							type="submit"
							className="mx-auto text-xs bg-green-600  py-2 rounded mt-4 text-white font-roboto px-16 mr-3"
							onClick={CaptureEventHandlerOK}
						>
							ACCEPT
						</button>
						<button
							type="button"
							className="mx-auto text-xs bg-white text-green-600 border py-2 rounded mt-4  font-roboto px-16 ml-3"
							onClick={CaptureEventHandlerReTake}
						>
							RE-TAKE
						</button>
					</div>
				) : has_permission ? (
					<div className="hidden md:block mx-auto" style={{ width: "150px" }}>
						<div
							// type="button"
							className="mx-auto text-xs bg-green-600  py-2 rounded mt-4 text-white font-roboto cursor-pointer"
							style={{ width: "150px" }}
							onClick={capture1}
						>
							Capture
						</div>
					</div>
				) : null}
			</div>
		</>
	);
};

export default WebcamCapture;
